export default __webpack_public_path__ + "static/media/other-infrastructure-component.71217b37.svg";